import React from 'react';
import { useTheme } from '../theming/default_theme';
interface StatusBadgeProps {
  backgroundColor: string;
  textColor: string;
  text: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ backgroundColor, textColor, text }) => {
  const theme=useTheme();
  return (
    <div
      className={`inline-block rounded-full py-1 px-4 text-center font-[${theme.typography.fontWeightRegular}] bg-[${backgroundColor}] text-[${textColor}]`}
      style={{
        backgroundColor,
        color:`${textColor}`,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.fontSize,
        lineHeight: '1.5',

      }}>
      {text}
    </div>
  );
};

export default StatusBadge;